// extracted by mini-css-extract-plugin
export default {"Container":"Wrapper_Container__BvRxJ"};